import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const PaymentWrapperStyles: StyleExtend<Theme> = {
  maxWidth: '545px',
  width: '100%',
  boxSizing: 'content-box',
  p: { xs: 3, sm: 4 },
  pb: { sm: 10 },
  display: 'flex',
  flexDirection: 'column',
};
